module.exports = __webpack_public_path__ + "img/coins-1.e9ea2084.png";